import React from 'react';
import styled from 'styled-components';

import { imageFix } from '../../../helpers';
import './SnapshotVideo.css';

interface Props {
  url: string;
  img: string;
  sound?: boolean;
  ig?: boolean;
  style?: any;
}

interface State {
  playing: boolean;
}

const Wrapper = styled.div`
  display: table;
  width: auto;
  position: relative;
  margin: auto;
`;

const PlayButton = styled.div`
  background-image: url(https://newimages.bwwstatic.com/2018/video-play-icon.png);
  background-repeat: no-repeat;
  width: 75px;
  height: 50%;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-size: contain;
  background-position: 50% 50%;
`;

class SnapshotVideo extends React.Component<Props, State> {
  video: any;

  constructor(props: Props) {
    super(props);
    this.state = { playing: false };
    this.play = this.play.bind(this);
  }

  play() {
    if (this.state.playing) {
      this.setState({ playing: false });
      this.video.pause();
    } else {
      this.setState({ playing: true });
      this.video.play();
    }
  }

  render() {
    const video = imageFix(this.props.url);
    const thumbnail = imageFix(this.props.img);

    return (
      <Wrapper>
        <video
          className="video ig-post"
          ref={(c) => {
            this.video = c;
          }}
          onClick={this.play}
          muted={!this.props.sound}
          poster={thumbnail}
          style={this.props.ig ? this.props.style : {}}
          onKeyDown={this.play}
        >
          <source src={video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <PlayButton
          onKeyDown={this.play}
          onClick={this.play}
          role="button"
          tabIndex={0}
          style={{ visibility: this.state.playing ? 'hidden' : 'visible' }}
        />
      </Wrapper>
    );
  }
}

export default SnapshotVideo;
